export default __webpack_public_path__ + "static/media/Open_Eye.bd91b9fe.svg";